<template>
    <section>
        <div class="main">
            <div class="text">
                <h2>{{ $t('homepage.e2ee.title') }}<a href="#tip" class="tip-link" v-anchor><sup>2</sup></a></h2>
                <p>{{ $t('homepage.e2ee.desc') }}</p>
            </div>
            <div class="poster" :style="`background-image: url(${poster});`"></div>
        </div>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import E2EEPoster from 'IMAGE/homepage/e2ee.jpg';

export default Vue.extend({
    data() {

        return {
            poster: E2EEPoster
        };

    }
});
</script>

<style lang="less" scoped>
section{
    background-color: @bg_03;
    padding: 80px 0;
    .mobile({
        padding: 32px 0;;
    });
    .main{
        display: flex;
        max-width: 1200px;
        gap: 32px;
        margin: 0 auto;
        align-items: center;
        .mobile({
            gap: 12px;
            flex-direction: column;
            .mobileMaxWidth();
        });
        .text{
            flex: 1;
            text-align: left;
            .mobile({
                text-align: center
            });
            h2{
                font-size: 36px;
                font-weight: 600;
                line-height: 60px;
                margin-bottom: 4px;
                .mobile({
                    font-size: 28px;
                });
            }
            p{
                font-size: 18px;
                font-weight: 400;
            }
        }
        .poster{
            height: 400px;
            width: 600px;
            border-radius: @border-radius-level-3;
            background-position: center;
            .mobile({
                width: 100%;
                aspect-ratio: 1.5;
                height: auto;
                background-size: 100% auto;
            });
        }
    }
}
</style>
